import { render, staticRenderFns } from "./rich_text.vue?vue&type=template&id=31d322a0&scoped=true"
import script from "./rich_text.vue?vue&type=script&lang=ts"
export * from "./rich_text.vue?vue&type=script&lang=ts"
import style0 from "./rich_text.vue?vue&type=style&index=0&id=31d322a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d322a0",
  null
  
)

export default component.exports